<template lang="pug">
  .fixed-header(ref='change')
    .fixed-header__wrap
      .title(ref='title' :class="{fixed, absolute,}")
        .title__item
          p {{ fieldTitle }}
        .title__item
          p {{ valuesTitle }}
    .fixed-header__content(ref='content')
      slot
</template>

<script>
export default {
  name: 'TableFixedHeader',
  props: {
    fieldTitle: {
      type: String,
      required: true,
    },
    relationshipTitle: {
      type: String,
      required: true,
    },
    valuesTitle: {
      type: String,
      required: true,
    },
  },
  data () {
    return {
      fixed: false,
      absolute: false,
    }
  },
  mounted () {
    window.addEventListener('scroll', this.onChangeScroll)
    window.addEventListener('resize', this.setContentWidth)
  },
  destroyed () {
    window.removeEventListener('scroll', this.onChangeScroll)
    window.removeEventListener('resize', this.setContentWidth)
  },
  methods: {
    setContentWidth () {
      if (!this.$refs.title && !this.$refs.content) return

      const titleWidth = Number((this.$refs.title.style.maxWidth).slice(0, -2))
      const contentWidth = Math.round(this.$refs.content.getBoundingClientRect().width)

      if (titleWidth !== contentWidth || !this.$refs.title.style.maxWidth && contentWidth !== 0) {
        this.$refs.title.style.maxWidth = Math.round(contentWidth) + 'px'
      }
    },
    onChangeScroll () {
      if (this.$refs.change && this.$refs.change.getBoundingClientRect().width > 768) {
        const { top, height, } = this.$refs.change.getBoundingClientRect()
        this.setContentWidth()

        if (top > 0) {
          this.fixed = false
        } else if ((top - 44) > -height) {
          this.fixed = true
          this.absolute = false
        } else if (top > -height || Math.abs(top) > height) {
          this.absolute = true
        }
      } else {
        this.fixed = false
      }
    },
  },
}
</script>

<style scoped lang="stylus">
  @import "../../../assets/styles/variables.styl"

  .absolute
    position: absolute!important
    top: inherit!important
    bottom: -2px

  .fixed
    position: fixed
    top: 0

  .fixed-header
    position relative
    width: 100%

    &__wrap
      min-height: 48px
      width: 100%

      .title
        display: grid
        grid-template-columns: 200px 1fr
        grid-column-gap: 10px
        margin-bottom: 2px
        width: inherit
        max-width: inherit

        &__item
          background-color: $default-color-light-1
          color: $default-color-bold
          font-weight: 600;
          padding: 15px 20px

  @media (max-width: $tablet)
    .fixed-header
      &__wrap
        display: none
</style>



// WEBPACK FOOTER //
// src/components/record-details/modifications/ModificationFixedHeader.vue